import { render, staticRenderFns } from "./TrainingCompletedCard.vue?vue&type=template&id=108cc8aa&scoped=true"
import script from "./TrainingCompletedCard.vue?vue&type=script&lang=js"
export * from "./TrainingCompletedCard.vue?vue&type=script&lang=js"
import style1 from "./TrainingCompletedCard.vue?vue&type=style&index=1&id=108cc8aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108cc8aa",
  null
  
)

export default component.exports